/// <reference path="../interfaces/Webshims.ts" />

declare var yepnope: Function;
declare var ko: any;
declare var $: any;

module Elma.ViewModels {
    export enum Mode { List = "list" as any, Grid = "grid" as any };

    export class MasterViewModel extends Tapas.ViewModels.MasterViewModel {
        public webshimsBasePath: KnockoutObservable<string> = ko.observable(""); // the path is defined inside body
        public itemCssClass = ko.observable("");
        public menuCssClass = ko.observable("");
        public subMenuCssClass = ko.observable("");
        public listMode: KnockoutObservable<Mode> = ko.observable(Mode.Grid);
        public compareProductsArray = ko.observableArray();

        private _checkoutFlowInit = false;

        constructor() {
            super();

            // Webshims polyfill til Safari/ældre browsere (required/HTML5 forms)
            this.webshimsBasePath.subscribe((newValue) => {
                if (newValue) {
                    var currentWebShimsPath = newValue;
                    var oldBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    yepnope([{
                        test: oldBrowser,
                        yep: [currentWebShimsPath],
                        callback: function () {
                            if (($ as any).webshims) {
                                ($ as any).webshims.polyfill("forms");
                            } else {
                                console.debug("webshims library not found");
                            }
                        }
                    }]);
                }
            });

            // Init checkout login/guest-flow + modal-centrering (kun i checkout)
            this.initCheckoutLoginFlow();
        }

        /**
         * Løsning 2:
         *  - Intercept "Fortsæt til betaling" hvis ikke logget ind
         *  - E-mail lookup → åbner login-modal
         *  - Viser note hvis e-mail findes
         *  - Altid “Fortsæt uden login” (med sessions-hukommelse)
         *  - Modal centreret kun i checkout
         */
        private initCheckoutLoginFlow(): void {
            if (this._checkoutFlowInit) return;
            this._checkoutFlowInit = true;

            var $jq = (window as any).jQuery || (window as any).$;
            if (!$jq) return;

            var $checkout = $jq('.section.checkout');
            if (!$checkout.length) return; // kun i checkout

            var host = window.location.hostname;
            function hostIs(pattern: RegExp): boolean { return pattern.test(window.location.hostname); }

            var API_URL =
                hostIs(/(^|\.)elma\.dk$/i)
                    ? 'https://elma.dk/elma-api/session/user/EmailLookup' // PROD
                    : hostIs(/(^|\.)elma\.dw9\.1stweb-staging\.net$/i)
                        ? 'https://elma.dw9.1stweb-staging.net/elma-api/session/user/EmailLookup' // STAGING
                        : 'https://elma.test001.webtester.dk/elma-api/session/user/EmailLookup'; // TEST

            var GUEST_KEY = 'elmaGuestCheckout';

            // server-renderet flag bruger vi til at skippe hele flowet ved login
            var LOGGED_IN = (function () {
                try {
                    // læses fra readonly-flag på e-mailfeltet senere; fallback her er false
                    return false;
                } catch (e) { return false; }
            })();

            // Hovedform i checkout
            var $form = $checkout.find('form#ordersubmit').first();
            if (!$form.length) return;

            // Find "næste step" submit (desktop); fallback til første submit-knap i formen
            var $nextBtn = $form.find('input[type="submit"].finish, #cartnextstepbtn, input[type="submit"]').first();
            if (!$nextBtn.length) return;

            // E-mail felt i formen
            var $mail = $form.find('input[type="email"], input[name*="Email"]').first();
            if (!$mail.length) return;

            // Logget ind? (templaten sætter readonly på e-mail-felt ved login)
            var isLoggedIn = $mail.is('[readonly]');
            if (isLoggedIn) return; // hvis logget ind, gør intet – brug DW standardflow

            // Mobil dummy-knap udenfor formen
            var $mobileDummy = $jq('#OrderSubmitDummy');

            // --- Modal centreret KUN i checkout ---
            var $loginModal = $jq('.loginModal');
            $loginModal
                .off('show.bs.modal.center')
                .on('show.bs.modal.center', function () {
                    $jq(this).addClass('modal--centered');
                })
                .off('hidden.bs.modal.center')
                .on('hidden.bs.modal.center', function () {
                    $jq(this).removeClass('modal--centered');
                });

            // --- Hjælpere ---
            var NEXT_NAME = ($nextBtn.attr('name') || '');

            function setGuestAlways() {
                try { sessionStorage.setItem(GUEST_KEY, '1'); } catch (e) { /* ignore */ }
            }
            function isGuestAlways() {
                try { return sessionStorage.getItem(GUEST_KEY) === '1'; } catch (e) { return false; }
            }

            function continueToNextStep() {
                $form.data('_ok', 1);
                var formEl: any = $form.get(0);

                if (formEl && typeof formEl.requestSubmit === 'function' && $nextBtn.get(0)) {
                    formEl.requestSubmit($nextBtn.get(0));
                } else {
                    // Sikr at NEXT-param følger med
                    if (NEXT_NAME && !$form.find('input[type="hidden"][data-emailguard="1"][name="' + NEXT_NAME + '"]').length) {
                        $jq('<input>', { type: 'hidden', name: NEXT_NAME, value: '1', 'data-emailguard': '1' }).appendTo($form);
                    }
                    var btnEl: any = $nextBtn.get(0);
                    if (btnEl && typeof btnEl.click === 'function') {
                        btnEl.click();
                    } else if (formEl && typeof formEl.submit === 'function') {
                        formEl.submit();
                    }
                }
            }

            function ensureLoginNote() {
                var id = 'loginModalNote';
                var $note = $jq('#' + id);
                if ($note.length) return $note;

                $note = $jq('<div/>', {
                    id: id,
                    'class': 'alert alert-info',
                    style: 'display:none; margin:8px 0 0 0;'
                }).html('Konto findes – log ind for hurtigere checkout, eller fortsæt som gæst.');
                $jq('.loginModal .modal-body:first .form').before($note);
                return $note;
            }

            function ensureGuestBtn() {
                var id = 'continueAsGuestBtn';
                var $g = $jq('#' + id);
                if ($g.length) return $g;

                $g = $jq('<button/>', {
                    id: id,
                    type: 'button',
                    'class': 'btn btn-secondary pull-right'
                }).text('Fortsæt uden login')
                    .css({ marginRight: '8px' })
                    .on('click', function () {
                        setGuestAlways();               // husk valget i session
                        try { ($jq('.loginModal') as any).modal('hide'); } catch (e) { /* ignore */ }
                        continueToNextStep();           // gå videre nu
                    });

                var $wrap = $jq('.loginModal .modal-buttons.pull-right');
                if ($wrap.length) { $g.prependTo($wrap); }
                return $g;
            }

            function openLoginModal(exists: boolean) {
                var $note = ensureLoginNote();
                var $gbtn = ensureGuestBtn();
                if (exists) { $note.show(); } else { $note.hide(); }
                $gbtn.show();
                try { ($jq('.loginModal') as any).modal('show'); } catch (e) { /* ignore */ }
            }

            function parseExists(data: any) {
                return (data === true) || (data === 'true') ||
                    (data && (data.exists === true || data.Value === true || data.result === true));
            }

            // --- Intercept submit (desktop + scripts) ---
            $form.off('submit.loginmodal').on('submit.loginmodal', function (e: any) {
                // allerede godkendt?
                if ($form.data('_ok')) return;

                // logget ind → kør normalt
                if (LOGGED_IN || isLoggedIn) return;

                // Hvis brugeren tidligere har valgt "Fortsæt uden login" i denne session → allow native submit (1 klik)
                if (isGuestAlways()) {
                    $form.data('_ok', 1);
                    return;
                }

                var v = String(($mail.val() || '')).trim();
                if (!v) return; // native required håndterer tom

                // stop og vis modal efter lookup
                e.preventDefault();

                $jq.ajax({
                    method: 'GET',
                    dataType: 'json',
                    url: API_URL,
                    data: { email: v }
                }).done(function (data: any) {
                    openLoginModal(!!parseExists(data));
                }).fail(function () {
                    // API nede → vis modal med “fortsæt uden login”
                    openLoginModal(false);
                });
            });

            // --- Mobil-knappen mimer samme flow ---
            if ($mobileDummy.length) {
                $mobileDummy.off('click.checkoutmodal').on('click.checkoutmodal', function (ev: any) {
                    ev.preventDefault();
                    $form.trigger('submit');
                });
            }
        }
    }
}
